export default "__VITE_ASSET__CrJjkaIJ__"